import cn from "classnames"

import { ArticlePreview } from "../molecules"

import type { PostModel } from "@serializers/article"

interface PostGridElementProps {
  posts: PostModel[]
  postUrlPrefix?: string
  hasRotation?: boolean
}

export function PostGridElement(props: PostGridElementProps) {
  const { posts, postUrlPrefix, hasRotation } = props

  const getPostsElements = () => {
    let index = 0
    let elements: JSX.Element[] = []
    const count = posts.length

    // Render posts with rotation
    if (hasRotation) {
      return posts.map((post, idx) => (
        <ArticlePreview
          key={post.id}
          article={post}
          urlPrefix={postUrlPrefix}
          classes={{
            container: `desktop-l:h-[709px] rotate-[${idx % 2 ? -1 : 1}deg]`,
          }}
        />
      ))
    }

    if (count > 1) {
      // 3 cards in a row
      const postsToRender = count === 4 ? posts.slice(0, 3) : posts
      elements = postsToRender.map((post) => (
        <ArticlePreview
          key={post.id}
          article={post}
          urlPrefix={postUrlPrefix}
          classes={{
            container: "desktop-l:h-[709px]",
          }}
        />
      ))
      index = postsToRender.length
    }

    if (count - index === 1) {
      // row with 1 card
      const post = posts[index++]
      elements.push(
        <ArticlePreview
          key={post.id}
          article={post}
          urlPrefix={postUrlPrefix}
          orientation="horizontal"
          classes={{
            container:
              "tablet-s:h-[300px] desktop:h-[441px] tablet-s:col-span-3",
          }}
        />,
      )
    }
    return elements
  }

  return (
    <div
      className={cn(
        "grid gap-3 tablet-s:grid-cols-3 tablet-s:gap-4 desktop-l:gap-6",
        hasRotation ? "desktop-l:gap-8" : "desktop-l:gap-6",
      )}
    >
      {getPostsElements()}
    </div>
  )
}
